import { CitizenshipSelectionOptions } from '@/features/section-1/features/citizenship-selection/application/domain/entities/CitizenshipSelection';

/**
 * What the I-9's "An alien authorized to work until (exp. date, if any)" box prints: the employee's
 * date, or "N/A" when they said their authorization does not expire (M-274 3.0). Only the employee
 * completes Section 1 (M-274 9.0), so an older I-9 left blank prints blank rather than an N/A nobody
 * chose (VTK-2071; VTK-2107 had inferred it). Both Section 1 generators (the printed I-9 and the
 * review screen's preview) use this, so they cannot disagree.
 */
export function workAuthorizationExpiry(section1: {
  citizenshipStatus?: string | null;
  expirationDate?: string | null;
  workAuthorizationNoExpiration?: boolean | null;
}): string {
  if (section1.expirationDate) return section1.expirationDate;
  return section1.citizenshipStatus === CitizenshipSelectionOptions.ALIEN &&
    section1.workAuthorizationNoExpiration === true
    ? 'N/A'
    : '';
}
